module.exports = __webpack_public_path__ + "static/media/reviews.8da21fe1.svg";